import React from 'react'
import logo from './logos/LOGO_XIVIX_LD.png'

function LogoWithCaptionWhite({className}) {
  return (
    <div className={className}>
      <img src={logo} alt="Xivix Logo"/>
    </div>
    )
  }

export default LogoWithCaptionWhite;
